import {
  WSActions,
  WSAlert,
  WSForm,
  WSFormProps,
  WSInfoBox,
  WSList
} from "@wingspanhq/fe-component-library";
import merge from "lodash/merge";
import { WSFormErrorSummary } from "../../../../shared/components/WSFormErrorSummary";
import { useModalWhyWeCollectInfo } from "../ModalWhyWeCollectInfo";
import { emptyValues } from "./emptyValues";
import { getValidationSchema } from "./validationSchema";
import {
  FormPartialDataUsPersonInfo,
  FormPartialUsPersonInfo
} from "../FormPartialUsPersonInfo";

export type FormDataUSInternationalPersonInformation = {
  usPerson: FormPartialDataUsPersonInfo;
};

type Props = {
  defaultValues?: WSFormProps<FormDataUSInternationalPersonInformation>["defaultValues"];
  onSubmit: WSFormProps<FormDataUSInternationalPersonInformation>["onSubmit"];
  onBack?: () => void;
  mismatch?: boolean;
  completed?: boolean;
};

export const FormUSInternationalPersonInformation: React.FC<Props> = ({
  defaultValues,
  onBack,
  onSubmit,
  mismatch,
  completed
}) => {
  const modal = useModalWhyWeCollectInfo();

  const formDefaultValues = merge(
    {
      ...emptyValues
    },
    {
      ...defaultValues
    }
  );

  return (
    <WSForm<FormDataUSInternationalPersonInformation>
      defaultValues={formDefaultValues}
      onSubmit={onSubmit}
      validationSchema={getValidationSchema()}
    >
      <WSList gap="2XL">
        {mismatch ? (
          <WSAlert
            icon="alert"
            theme="warning"
            title="IRS TIN Mismatch Detected"
          >
            <WSInfoBox transparent>
              <p>
                The information you provided does not match IRS records. Please
                review and update:
              </p>
              <ul>
                <li>
                  Full Legal Name (as it appears on your Social Security card)
                </li>
                <li>Social Security Number (SSN)</li>
              </ul>
              <p>To ensure accuracy:</p>
              <ol>
                <li>Double-check for typos or transposed numbers</li>
                <li>Verify your name exactly matches IRS records</li>
                <li>
                  For recent name changes, ensure you've updated the Social
                  Security Administration or IRS
                </li>
                <li>
                  Confirm you're using the correct TIN type (SSN vs EIN) for
                  your situation
                </li>
              </ol>
            </WSInfoBox>
          </WSAlert>
        ) : null}

        <FormPartialUsPersonInfo
          mismatch={mismatch}
          name="usPerson"
          completed={completed}
        />

        <WSFormErrorSummary />

        <WSActions
          alignment="fill"
          buttons={[
            {
              label: "Back",
              onClick: onBack,
              kind: "Secondary",
              type: "button",
              visible: !!onBack
            },
            {
              label: "Continue"
            }
          ]}
        />
      </WSList>
    </WSForm>
  );
};
